(function () {
    'use strict';

    angular.module('app.opsConfig', [
        'app.core',
        'app.widgets'
    ]);
})();
